<template >
  <div name="documents">
     <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Resource Admin</h2>
      </div>
    </header>

     <div
      class="header-subnav-holder">
      <button
        type="button"
        class="header-subnav focus:outline-none"
        @click="libraryType = 'primary'"
        v-bind:class="[libraryType === 'primary' ? 'selected' : '']"
      >
        Primary
      </button>

          <button
        type="button"
        class="header-subnav focus:outline-none"
        @click="libraryType = 'secondary'"
        v-bind:class="[libraryType === 'secondary' ? 'selected' : '']"
      >
        Secondary
      </button>
    </div>

    <div class="table-wrapper">
      <div v-if="errored" class="empty">
        <p>
          We are not able to retrieve this information at the moment, please try
          back later
        </p>
      </div>

      <div id="content-area" class="w-full mx-auto h-full pb-16" v-else>
        <div v-if="!hasSearch"
        class="grid grid-cols-6 gap-6 w-11/12 mx-auto pt-10"
      >
        <div
          v-for="type in typeList" :key="type.id"
          @click="showResources(type)"
          class="text-center content-center rounded-2xl p-6 cursor-pointer hover:opacity-50 bg-gray-100"
        >
          <div class="icon bg-gray-100 rounded-xl w-10 h-8 pt-3 mx-auto">
             <i class="fas  text-xl mx-auto opacity-75 text-gray-600"
             v-bind:class="type.icon != undefined ? type.icon : 'fa-folder-minus'" ></i>
          </div>
          <h4 class="pt-3 font-bold">{{ type.name }}</h4>
        </div>
      </div>

 
   
    </div>
    </div>

   

    <ModalSlide v-if="typeSelected != null"  :show="showModalList"     :cssWidth="'md:w-6/12'"  @closeModal="closeListResource">
      <template v-slot:header-icon>
        <i class="fas fa-plus"></i>
      </template>
      <template v-slot:header-title>
       {{ typeSelected.name }} Resources
        <div class="text-xs">View resource files.</div>
      </template>
      <template v-slot:body>
        <ResourceList :hasAccess="true"  :type="typeSelected" ></ResourceList>
      </template>
    </ModalSlide>

        
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { libraryFolders } from "@/assets/js/utils";

const ModalSlide = () => import("@/components/ModalSlide.vue");
const ResourceAdd = () => import("@/components/library/TheResourceAdd.vue");
const ResourceList = () => import("@/components/library/TheResourceList.vue");


export default {
  name: "documents",
  props: {},
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    schoolName() {
      return this.currentUser.schoolName;
    },
    typeList() {
      return libraryFolders(this.libraryType)
    }
  },
  data() {
    return {
      loading: true,
      errored: false,
      showModalList: false,
      typeSelected: null,
      search: "",
      hasSearch: false,
      libraryType: "primary"

    };
  },
  created() {
    this.loading = true;
  },
  mounted() {
  },
  methods: {
    addNew() {
      this.showModalAddition = true;
    },
    closeListResource() {
      this.showModalList = false;
      this.typeSelected = null
    },
    resourceAdded() {
      this.closeAddResource()
    },
    showResources(type) {
      this.typeSelected = type
      this.showModalList = true
    },
  },
  components: {
    ResourceAdd,
    ResourceList,
    ModalSlide
  },
};
</script>

<style>

</style>


